'use client';

import { SolidityResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: SolidityResult;
  translations: ToolsTranslations['solidity'];
  equity: number;
  totalAssets: number;
  currency: string;
}

export default function ResultsDisplay({ result, translations, equity, totalAssets }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.solidityPercent !== null ? `${result.solidityPercent.toFixed(2)}%` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>

      {result.isValid && result.solidityPercent !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.equity}:</span><span className="font-medium">{equity.toLocaleString()} {translations.currencySuffix}</span></div>
            <div className="flex justify-between"><span className="text-gray-600">{translations.additionalInfo.totalAssets}:</span><span className="font-medium">{totalAssets.toLocaleString()} {translations.currencySuffix}</span></div>
          </div>
        </div>
      )}
    </div>
  );
}


